import React from "react";
import { useParams } from "react-router-dom";

import { useQueryGetUnit } from "@examspark/common-app";

import Unit from "../../components/unit/Unit";

const UnitRoute = () => {
  const params = useParams<{
    id: string;
  }>();

  const { data } = useQueryGetUnit(params.id, "unit#v0", true);

  return <>{data && <Unit unit={data} routerUnitId={params.id} />}</>;
};

export default UnitRoute;
